module.exports = __webpack_public_path__ + "i18n/es_d32f14f4ad757234527c45ace46e2054.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 153